export default __webpack_public_path__ + "static/media/kakaopay.a652815d.png";